export const canAdministerCommunityOfferTopics = (
	user?: { type?: string } | null,
) => user?.type === 'ADMIN' || user?.type === 'SUPERADMIN';
